import React from 'react'
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import { MuiInput } from "../../components/basicComponent/MuiInput";
import { MuiDropDown } from "../../components/basicComponent/MuiDropDown";
import MuiButton from "../../components/basicComponent/MuiButton";
import MuiDatePicker from "../../components/basicComponent/MuiDatePicker";
import MuiSearchSelect from "../../components/basicComponent/MuiSearchSelect";
import Header from "../../sharedScreens/Header";
const BookVisa = () => {
  return (
    <div className="grow">
    <SideMenu />
    <div className="wrapper flex grow flex-col">
      <Header />
      <main className="grow content" id="content" role="content">
        <div className="container-fixed">
          <div className="card-header text-center">
            <h3 className="card-title">Visa Search</h3>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card card-custom">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4 mt-3">
                      <MuiSearchSelect
                        placeholder={"Destination"}
                        label="Destination "
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>

                    <div className="col-md-4 mt-3">
                      <MuiSearchSelect
                        placeholder={"Traveller "}
                        label="Traveller "
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>

                    <div className="col-md-4 mt-3">
                      <MuiSearchSelect
                        placeholder={"CustomerName"}
                        label="CustomerName "
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>
              

                   
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                        marginTop: "8px",
                      }}
                    >
                      <div className="user-button w-full">
                        <MuiButton
                          className="main-btn get-btn"
                          variant="contained"
                          size="large"
                          type="submit"
                          label={"Search Now"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
  )
}

export default BookVisa
